import { every, isEmpty } from 'lodash';
import React, { useContext, useEffect, useState } from 'react';
import { useMap } from 'react-use';

export const IndividualCreatedMessagesCtx = React.createContext();

export const IndividualCreatedMessagesProvider = ({ children }) => {
  const [personCreationErrors, personCreationErrorsActions] = useMap({});
  const [personCreationSuccess, setPersonCreationSuccess] = useState(null);

  useEffect(() => {
    if (!isEmpty(personCreationErrors)) {
      const result = every(personCreationErrors, (v, k) => {
        return !v;
      });

      setPersonCreationSuccess(result);
    }
  }, [personCreationErrors]);
  return (
    <IndividualCreatedMessagesCtx.Provider
      value={{
        personCreationErrors,
        personCreationSuccess,
        setPersonCreationErrors: personCreationErrorsActions.setAll,
        personCreationErrorsActions,
      }}
    >
      {children}
    </IndividualCreatedMessagesCtx.Provider>
  );
};

export const useIndividualCreatedMessages = () => {
  const value = useContext(IndividualCreatedMessagesCtx);
  if (!value || isEmpty(value))
    throw new Error(
      'useIndividualCreatedMessages must be use in IndividualCreatedMessagesProvider'
    );
  return value;
};
